import React from 'react';
import { COLORS } from '../../utils/constants';

const Button = ({ children, primary = true, onClick, className = "" }) => (
  <button
    onClick={onClick}
    className={`group px-2 py-3 rounded-lg font-semibold transition-all duration-300 ${
      primary
        ? 'bg-blue-600 text-white hover:bg-black'
        : 'bg-black text-white hover:bg-gray-800'
    } ${className}`}
    style={{
      backgroundColor: primary ? COLORS.blue : COLORS.black,
      color: COLORS.white
    }}
  >
    <span className="inline-flex items-center gap-2">
      {children}
      <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
     
      </span>
    </span>
  </button>
);

export default Button;